<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner-list">
    <div class="row mb-4">
      <div class="col-md-5">
        <div class="title-wrapper">
          <div>
            <h1 class="title-default">Controle de Estoque</h1>
            <p class="welcome-message">
              Gerencie entradas, saídas e movimentações de estoque em tempo real.
            </p>
          </div>
        </div>
      </div>

      <div class="col-md-7 header-actions">
        <button mat-stroked-button class="btn-secondary" [matMenuTriggerFor]="opcoesMenu">
          <span>Ações</span>
          <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>

        <mat-menu #opcoesMenu="matMenu">
          <button mat-menu-item (click)="navegarParaTransferencia()">
            <mat-icon class="material-symbols-outlined">sync_alt</mat-icon>
            <span>Transferência de Estoque</span>
          </button>
          <button mat-menu-item routerLink="/suprimentos/inventario">
            <mat-icon class="material-symbols-outlined">fact_check</mat-icon>
            <span>Inventário de Estoque</span>
          </button>
          <button mat-menu-item (click)="exportarControleEstoque()">
            <mat-icon class="material-symbols-outlined">file_upload</mat-icon>
            <span>Exportar</span>
          </button>
          <button mat-menu-item (click)="imprimirRelatorio()">
            <mat-icon class="material-symbols-outlined">print</mat-icon>
            <span>Imprimir</span>
          </button>
        </mat-menu>

        <button type="button" mat-stroked-button class="btn-secondary" (click)="navegarParaTransferencia()">
          <mat-icon class="material-symbols-outlined">sync_alt</mat-icon>
          Transferência de Estoque
        </button>

        <button type="button" mat-flat-button class="btn-primary" routerLink="/suprimentos/inventario">
          <span class="material-symbols-outlined">fact_check</span>
          Inventário de Estoque
        </button>
      </div>
    </div>

    <form [formGroup]="model" (ngSubmit)="clickPesquisar()">
      <div class="row search-area">
        <div class="col-12 col-lg-6">
          <mat-form-field appearance="outline">
            <mat-label>Pesquisar</mat-label>
            <input matInput type="text" formControlName="pesquisa"
              placeholder="Pesquise por descrição, SKU, EAN, fornecedor ou série" />

            <button mat-icon-button matSuffix [matMenuTriggerFor]="refinarMenu" type="button" aria-label="Refinar busca"
              matTooltip="Refinar busca">
              <mat-icon>tune</mat-icon>
            </button>
            <mat-menu #refinarMenu="matMenu">
              <button mat-menu-item (click)="filtroRefinar = null">
                @if (filtroRefinar === null) {
                <mat-icon>check</mat-icon>
                }
                <span [class.ps-4]="filtroRefinar !== null">Não refinar</span>
              </button>
              <button mat-menu-item (click)="filtroRefinar = _refinamentoEnum.Descricao">
                @if (filtroRefinar === _refinamentoEnum.Descricao) {
                <mat-icon>check</mat-icon>
                }
                <span [class.ps-4]="filtroRefinar !== _refinamentoEnum.Descricao">Descrição</span>
              </button>
              <button mat-menu-item (click)="filtroRefinar = _refinamentoEnum.CodigoSku">
                @if (filtroRefinar === _refinamentoEnum.CodigoSku) {
                <mat-icon>check</mat-icon>
                }
                <span [class.ps-4]="filtroRefinar !== _refinamentoEnum.CodigoSku">SKU</span>
              </button>
              <button mat-menu-item (click)="filtroRefinar = _refinamentoEnum.GtinEan">
                @if (filtroRefinar === _refinamentoEnum.GtinEan) {
                <mat-icon>check</mat-icon>
                }
                <span [class.ps-4]="filtroRefinar !== _refinamentoEnum.GtinEan">EAN</span>
              </button>
              <button mat-menu-item (click)="filtroRefinar = _refinamentoEnum.CodigoFornecedor">
                @if (filtroRefinar === _refinamentoEnum.CodigoFornecedor) {
                <mat-icon>check</mat-icon>
                }
                <span [class.ps-4]="filtroRefinar !== _refinamentoEnum.CodigoFornecedor">Código do fornecedor</span>
              </button>
              <button mat-menu-item (click)="filtroRefinar = _refinamentoEnum.NumeroSerie">
                @if (filtroRefinar === _refinamentoEnum.NumeroSerie) {
                <mat-icon>check</mat-icon>
                }
                <span [class.ps-4]="filtroRefinar !== _refinamentoEnum.NumeroSerie">Número de série</span>
              </button>
            </mat-menu>

            <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div class="col-12 col-lg-6 filter-container">
          <button #filtrosAvancadosMenuTrigger="matMenuTrigger" mat-stroked-button type="button" class="btn-filter"
            [matMenuTriggerFor]="filtroMenu" [matBadge]="qtdFiltrosAvancados"
            [matBadgeHidden]="qtdFiltrosAvancados === 0">
            <mat-icon>filter_list</mat-icon>
            Filtrar
          </button>

          <mat-menu #filtroMenu="matMenu" class="filter-custom-menu">
            <div class="filter-menu-content" [formGroup]="model" (click)="$event.stopPropagation()">
              <h6>Filtros</h6>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Tipo</mat-label>
                <mat-select formControlName="idTipoMovimentoFiltro">
                  <mat-option [value]="_tipoMovimentoFiltroEnum.SemFiltro">Sem filtro</mat-option>
                  <mat-option [value]="_tipoMovimentoFiltroEnum.Entrada">Entrada</mat-option>
                  <mat-option [value]="_tipoMovimentoFiltroEnum.Saida">Saída</mat-option>
                  <mat-option [value]="_tipoMovimentoFiltroEnum.Inventario">Inventário</mat-option>
                </mat-select>
              </mat-form-field>
              <div class="filter-menu__actions">
                <button mat-button class="btn-secondary" matMenuClose
                  (click)="filtrosAvancadosMenuTrigger.closeMenu()">Cancelar</button>
                <button mat-flat-button class="btn-primary" (click)="aplicarFiltros()" matMenuClose>Aplicar</button>
              </div>
            </div>
          </mat-menu>

          <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltros()">
            <mat-icon>cleaning_services</mat-icon>
            Limpar Filtros
          </button>

          <button mat-stroked-button type="button" class="btn-filter desktop-view" (click)="configurarColunas()">
            <mat-icon>view_column</mat-icon>
            Configurar Colunas
          </button>
        </div>
      </div>
    </form>

    <div class="cards-filtro">
      <div class="cards-filtro-grade">
        <button type="button" class="card-filtro card-filtro-cinza"
          [class.active]="resumoFiltro === _resumoFiltroEnum.Todos"
          matTooltip="Total geral de itens cadastrados."
          (click)="selecionarResumo(_resumoFiltroEnum.Todos)">
          <span class="card-filtro-rotulo"><span class="dot"></span>Todos</span>
          <span class="card-filtro-valor">{{ getResumoValor(_resumoFiltroEnum.Todos) }}</span>
          <span class="card-filtro-sub">produtos cadastrados</span>
        </button>
        <button type="button" class="card-filtro card-filtro-vinho"
          [class.active]="resumoFiltro === _resumoFiltroEnum.EstoqueZerado"
          matTooltip="Nenhuma unidade disponível no inventário físico."
          (click)="selecionarResumo(_resumoFiltroEnum.EstoqueZerado)">
          <span class="card-filtro-rotulo"><span class="dot"></span>Estoque zerado</span>
          <span class="card-filtro-valor">{{ getResumoValor(_resumoFiltroEnum.EstoqueZerado) }}</span>
          <span class="card-filtro-sub">sem unidade em estoque</span>
        </button>
        <button type="button" class="card-filtro card-filtro-laranja"
          [class.active]="resumoFiltro === _resumoFiltroEnum.EstoqueBaixo"
          matTooltip="Itens no limite mínimo. Planeje a compra para não ficar sem."
          (click)="selecionarResumo(_resumoFiltroEnum.EstoqueBaixo)">
          <span class="card-filtro-rotulo"><span class="dot"></span>Estoque baixo</span>
          <span class="card-filtro-valor">{{ getResumoValor(_resumoFiltroEnum.EstoqueBaixo) }}</span>
          <span class="card-filtro-sub">no limite mínimo de reposição</span>
        </button>
        <button type="button" class="card-filtro card-filtro-amarelo"
          [class.active]="resumoFiltro === _resumoFiltroEnum.Reservado"
          matTooltip="Itens com saldo reservado."
          (click)="selecionarResumo(_resumoFiltroEnum.Reservado)">
          <span class="card-filtro-rotulo"><span class="dot"></span>Reservado</span>
          <span class="card-filtro-valor">{{ getResumoValor(_resumoFiltroEnum.Reservado) }}</span>
          <span class="card-filtro-sub">com saldo reservado</span>
        </button>
        <button type="button" class="card-filtro card-filtro-verde"
          [class.active]="resumoFiltro === _resumoFiltroEnum.Disponivel"
          matTooltip="Itens com saldo livre para vender ou movimentar."
          (click)="selecionarResumo(_resumoFiltroEnum.Disponivel)">
          <span class="card-filtro-rotulo"><span class="dot"></span>Disponível</span>
          <span class="card-filtro-valor">{{ getResumoValor(_resumoFiltroEnum.Disponivel) }}</span>
          <span class="card-filtro-sub">com saldo livre para vender</span>
        </button>
      </div>

      <div class="cards-filtro-select">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Filtrar por</mat-label>
          <mat-select [value]="resumoFiltro" (selectionChange)="selecionarResumo($event.value)">
            <mat-select-trigger>
              <span class="dot dot-filtro" [ngClass]="getResumoCorClass(resumoFiltro)"></span>
              {{ getLabelResumoFiltro(resumoFiltro) }} ({{ getResumoValor(resumoFiltro) }})
            </mat-select-trigger>
            <mat-option [value]="_resumoFiltroEnum.Todos">
              <span class="dot dot-filtro card-filtro-cinza"></span>
              Todos ({{ getResumoValor(_resumoFiltroEnum.Todos) }})
            </mat-option>
            <mat-option [value]="_resumoFiltroEnum.EstoqueZerado">
              <span class="dot dot-filtro card-filtro-vinho"></span>
              Estoque zerado ({{ getResumoValor(_resumoFiltroEnum.EstoqueZerado) }})
            </mat-option>
            <mat-option [value]="_resumoFiltroEnum.EstoqueBaixo">
              <span class="dot dot-filtro card-filtro-laranja"></span>
              Estoque baixo ({{ getResumoValor(_resumoFiltroEnum.EstoqueBaixo) }})
            </mat-option>
            <mat-option [value]="_resumoFiltroEnum.Reservado">
              <span class="dot dot-filtro card-filtro-amarelo"></span>
              Reservado ({{ getResumoValor(_resumoFiltroEnum.Reservado) }})
            </mat-option>
            <mat-option [value]="_resumoFiltroEnum.Disponivel">
              <span class="dot dot-filtro card-filtro-verde"></span>
              Disponível ({{ getResumoValor(_resumoFiltroEnum.Disponivel) }})
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    @if (_response && _dataSource.data.length > 0) {
    <div class="table-container desktop-view">
    <table mat-table class="desktop-view" [dataSource]="_flatDataSource" matSort>
      <ng-container matColumnDef="produto">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Produto</th>
        <td mat-cell *matCellDef="let row">
          @if (row.isLocal) {
          <span class="local-indent">
            <mat-icon class="local-link-icon">subdirectory_arrow_right</mat-icon>
          </span>
          } @else {
          {{ row.data.descricao }}
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="codigoSku">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>SKU</th>
        <td mat-cell *matCellDef="let row">{{ row.isLocal ? '' : row.data.codigoSku }}</td>
      </ng-container>

      <ng-container matColumnDef="local">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Local</th>
        <td mat-cell *matCellDef="let row">
          @if (row.isLocal) {
          <span class="local-name">{{ getLocalizacao(row) }}</span>
          } @else if (row.data.quantidadeLocais > 1) {
          <span class="badge-locais">
            {{ getLocalizacao(row) }}
            <mat-icon class="icon-expand">{{ expandedElement === row.data ? 'expand_less' : 'expand_more' }}</mat-icon>
          </span>
          } @else {
          {{ getLocalizacao(row) }}
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="unidade">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Unid.</th>
        <td mat-cell *matCellDef="let row">{{ row.isLocal ? '' : row.data.unidade }}</td>
      </ng-container>

      <ng-container matColumnDef="reservado">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Reservado</th>
        <td mat-cell *matCellDef="let row" class="text-end">{{ getReservado(row) | abnt:'quantidade' }}</td>
      </ng-container>

      <ng-container matColumnDef="disponivel">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Disponível</th>
        <td mat-cell *matCellDef="let row" class="text-end">{{ getDisponivel(row) | abnt:'quantidade' }}</td>
      </ng-container>

      <ng-container matColumnDef="custoMedio">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Custo médio</th>
        <td mat-cell *matCellDef="let row" class="text-end">{{ row.isLocal ? '' : (row.data.custoMedio | abnt:'preco') }}</td>
      </ng-container>

      <ng-container matColumnDef="custoTotal">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Custo total</th>
        <td mat-cell *matCellDef="let row" class="text-end">{{ row.isLocal ? '' : (row.data.custoTotal | abnt:'preco') }}</td>
      </ng-container>

      <ng-container matColumnDef="preco">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Preço</th>
        <td mat-cell *matCellDef="let row" class="text-end">{{ row.isLocal ? '' : (row.data.preco | abnt:'preco') }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
        <td mat-cell *matCellDef="let row" class="text-center w-actions">
          @if (!row.isLocal) {
          <button mat-icon-button class="icon-mat-symbols-btn" [matMenuTriggerFor]="menuRow" aria-label="Ações"
            (click)="$event.stopPropagation()">
            <span class="material-symbols-outlined">more_horiz</span>
          </button>
          <mat-menu #menuRow="matMenu">
            <button mat-menu-item (click)="verMovimentacoes(row.data)">
              <span class="material-symbols-outlined">tab_move</span>
              <span>Movimentações</span>
            </button>
            <button mat-menu-item (click)="imprimirEtiquetas(row.data)">
              <span class="material-symbols-outlined">label</span>
              <span>Imprimir etiquetas</span>
            </button>
          </mat-menu>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" [class.local-row]="row.isLocal"
        [class.parent-expanded-row]="!row.isLocal && expandedElement === row.data"
        (click)="toggleRow(row)" [style.cursor]="isRowExpandivel(row) ? 'pointer' : 'default'"></tr>
    </table>
    </div>

    <div class="mobile-view">
      @for (produto of _dataSource.data; track produto.idProduto) {
      <div class="stock-card-mobile" [class.parent-expanded-row]="expandedElement === produto">
        <div class="stock-card-mobile__header">
          <div>
            <strong>{{ produto.descricao }}</strong>
            @if (produto.codigoSku) {
            <small>SKU: {{ produto.codigoSku }}</small>
            }
          </div>
          <button mat-icon-button class="icon-mat-symbols-btn" [matMenuTriggerFor]="menuMobile" aria-label="Ações">
            <span class="material-symbols-outlined">more_horiz</span>
          </button>
          <mat-menu #menuMobile="matMenu">
            <button mat-menu-item (click)="verMovimentacoes(produto)">
              <span class="material-symbols-outlined">swap_vert</span>
              <span>Movimentações</span>
            </button>
            <button mat-menu-item (click)="imprimirEtiquetas(produto)">
              <span class="material-symbols-outlined">label</span>
              <span>Imprimir etiquetas</span>
            </button>
          </mat-menu>
        </div>
        <div class="stock-card-mobile__grid">
          <div>
            <small>Reservado</small>
            <span>{{ produto.saldoReservado | abnt:'quantidade' }}</span>
          </div>
          <div>
            <small>Disponível</small>
            <span>{{ produto.saldoDisponivel | abnt:'quantidade' }}</span>
          </div>
          <div>
            <small>Preço</small>
            <span>{{ produto.preco | abnt:'preco' }}</span>
          </div>
          <div>
            <small>Local</small>
            @if (produto.quantidadeLocais > 1) {
            <span class="local-unico">{{ produto.quantidadeLocais }} locais</span>
            } @else {
            <span class="local-unico">{{ produto.localizacao || 'Sem local' }}</span>
            }
          </div>
        </div>

        @if (produto.quantidadeLocais > 1) {
        <div class="stock-card-mobile__locais-toggle">
          <button mat-button color="primary" type="button" class="w-100 text-start ps-0"
            (click)="toggleMobileProduto(produto)">
            <mat-icon>{{ expandedElement === produto ? 'expand_less' : 'expand_more' }}</mat-icon>
            {{ produto.quantidadeLocais }} Locais
          </button>

          @if (expandedElement === produto) {
          <div class="stock-card-mobile__locais">
            @for (local of produto.locais; track local.idLocalizacaoEstoque) {
            <div class="local-item">
              <span class="local-name">{{ local.localizacao || local.codigoLocalizacao || 'Local não informado'
                }}</span>
              <span class="local-saldo">Disp.: {{ local.saldoDisponivel | abnt:'quantidade' }}</span>
            </div>
            }
          </div>
          }
        </div>
        }
      </div>
      }
    </div>

    <div class="col-12 text-center">
      <button mat-button [disabled]="_ultimaPagina" (click)="proximaPagina()">
        @if (_isLoading === true) {
        <mat-spinner [diameter]="20"></mat-spinner>
        } @else {
        <span class="material-symbols-outlined">expand_more</span>
        Ver Mais
        }
      </button>
    </div>
    } @else if (_isLoading === true && _dataSource.data.length === 0) {
    <app-loading-box-default-list></app-loading-box-default-list>
    } @else {
    <app-empty-list [title]="'Nenhum produto encontrado'"
      [subTitle]="'Tente alterar os filtros de busca'"></app-empty-list>
    }
  </div>
</div>
